import { createApp } from 'vue'
import { createPinia } from 'pinia'
import '../app.css'
import App from '../App.vue'
import router from '../router'
import { initSentry } from '../lib/sentry'

// Evolution: Toolbox branding
// Most of the logic is now centralized in App.vue and router/index.ts
// but we keep this entry point for Vite build consistency.

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
initSentry(app, router)
app.mount('#app')
